import { coerceParametersFromMap } from './coerceParametersFromMap'
import type { BuildInstanceExecutionParamsParams } from './interfaces/buildInstanceExecutionParamsParams.interface'
import type { BuildInstanceExecutionParamsResult } from './interfaces/buildInstanceExecutionParamsResult.interface'

export const buildInstanceExecutionParams = ({
  isStatic,
  classData,
  selectedConstructorId,
  constructorValueMap,
}: BuildInstanceExecutionParamsParams): BuildInstanceExecutionParamsResult => {
  if (isStatic || !selectedConstructorId || !classData.constructors) {
    return { instanceParams: [] }
  }

  const selectedConstructor = classData.constructors[selectedConstructorId]
  if (!selectedConstructor) {
    return { instanceParams: [] }
  }

  return {
    instanceParams: coerceParametersFromMap({
      parameters: selectedConstructor.parameters,
      valueMap: constructorValueMap,
    }),
    constructorKey: selectedConstructorId,
  }
}
